import { BackButton } from './buttons/BackButton'
import { ConfirmOrderButton } from './buttons/ConfirmOrderButton'
import { CancelCheckoutButton } from './buttons/CancelCheckoutButton'
import { PaymentMethodPanel } from './panels/PaymentMethodPanel'
import type { FunctionComponent } from 'react'
import { NullComponent } from '@ztechapps/webui.util'
import { PaymentMethodButton } from './buttons/PaymentMethodButton'
import { ShippingRatePanelEmptyResult } from './panels/ShippingRatePanel/ShippingRatePanelEmptyResult'
import { ShippingRatePanel } from './panels/ShippingRatePanel'
import { ManualShippingRate } from './panels/ShippingRatePanel/ManualShippingRate'

export type Components = {
  itemPanel: FunctionComponent
  backButton: FunctionComponent
  confirmOrderButton: FunctionComponent
  cancelCheckoutButton: FunctionComponent
  paymentMethodPanel: FunctionComponent
  emailLink: FunctionComponent
  paymentMethodButton: FunctionComponent
  shippingRateEmptyResult: FunctionComponent
  manualShippingRate: FunctionComponent
  shippingRatePanel: FunctionComponent
  paymentButton: FunctionComponent
}

export const defaultComponents: Components = {
  //item panel ad sub-components
  itemPanel: NullComponent,

  //shipping rate panels and sub-components
  shippingRatePanel: ShippingRatePanel,
  manualShippingRate: ManualShippingRate,
  shippingRateEmptyResult: ShippingRatePanelEmptyResult,

  //payment method panel and sub-components
  paymentMethodPanel: PaymentMethodPanel,

  //button actions for each step
  backButton: BackButton,
  paymentMethodButton: PaymentMethodButton,
  confirmOrderButton: ConfirmOrderButton,
  cancelCheckoutButton: CancelCheckoutButton,
  paymentButton: NullComponent,

  //other components
  emailLink: NullComponent,
}
